
import { useStore } from "@/store";
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  setup() {
    const saveId = ref(1);
    const store = useStore();
    watch(saveId, () => {
      store.commit("setSaveId", { id: saveId.value });
      store.dispatch("loadData", { id: saveId.value });
    });
    return {
      saveId,
    };
  },
});
